import React, { useState, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import { FaPrint } from "react-icons/fa";

const ModalEtiquetaManual = ({ show, onHide, onImprimir }) => {
  const [nome, setNome] = useState("");
  const [cargo, setCargo] = useState("");
  const [empresa, setEmpresa] = useState("");

  const reset = useCallback(() => {
    setNome("");
    setCargo("");
    setEmpresa("");
  }, []);

  const handleClose = useCallback(() => {
    reset();
    onHide();
  }, [onHide, reset]);

  const handleImprimir = useCallback(() => {
    const nomeTrim = nome.trim();
    if (!nomeTrim) return;

    onImprimir({
      nome: nomeTrim,
      cargo: cargo.trim(),
      empresa: empresa.trim(),
      mostrarQr: false,
    });
    handleClose();
  }, [nome, cargo, empresa, onImprimir, handleClose]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="aet-manual-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Etiqueta manual</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="aet-modal-hint">
          Digite os textos que serão impressos na etiqueta. Etiquetas manuais
          não incluem QR Code.
        </p>
        <div className="aet-modal-field">
          <label htmlFor="aet-manual-nome">Nome</label>
          <input
            id="aet-manual-nome"
            type="text"
            className="form-control"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            placeholder="Nome em destaque"
            autoFocus
          />
        </div>
        <div className="aet-modal-field">
          <label htmlFor="aet-manual-cargo">Cargo</label>
          <input
            id="aet-manual-cargo"
            type="text"
            className="form-control"
            value={cargo}
            onChange={(e) => setCargo(e.target.value)}
            placeholder="Cargo"
          />
        </div>
        <div className="aet-modal-field">
          <label htmlFor="aet-manual-empresa">Empresa</label>
          <input
            id="aet-manual-empresa"
            type="text"
            className="form-control"
            value={empresa}
            onChange={(e) => setEmpresa(e.target.value)}
            placeholder="Empresa"
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="aet-manual-modal-footer">
        <button
          type="button"
          className="apl-btn apl-btn--ghost"
          onClick={handleClose}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="apl-btn apl-btn--primary"
          onClick={handleImprimir}
          disabled={!nome.trim()}
        >
          <FaPrint size={14} aria-hidden />
          Imprimir
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEtiquetaManual;
